import { Box, Card, CardContent, Typography } from "@mui/material"

const ChartCard = ({ children, title }) =>
  <Card sx={{ mb: 2 }}>
    <CardContent sx={{ p: 2 }}>
      <Typography variant='subtitle' gutterBottom>
        {title}
      </Typography>
      {/* // ** The chart needs an exclusive container for responsiveness */}
      <Box sx={{ position: "relative", height: "40vh", width: "80vw" }}>
        {children}
      </Box>
    </CardContent>
  </Card>

export default ChartCard